import React, { Component } from 'react';
import 'rc-dialog/assets/bootstrap.css';
import Dialog from 'rc-dialog';
import ClienteDialogContent from './ClienteDialogContent';

const DialogTitle = ({closeFn, text}) => {

  return(
  <span>
    <h2 className="ClienteDialogTitle">
      {text}
      <span className="ti ti-close CloseDialogCross" onClick={() => closeFn()}></span>
    </h2>
  </span>
  );

}

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = { visible: false };
    }

    openModal() {
        this.setState({ visible: true });
    }

    onClose() {
        this.setState({ visible: false });
    }

    render() {

        const dialogTitle = "Datos de " + this.props.cliente.nombre;

        return (
            <div style={{ marginLeft: '20px' }}>

                <div className="ClienteHeader">
                    <h1>María José Truglia</h1>
                    <span>
                    <span className="ti ti-user violeta-claro"></span>&nbsp;
                      <label>CUIL 27-10781311-3</label>
                    </span>
                </div>

                <div>
                  <button className="btn btn-default btn-secondary" onClick={() => this.openModal()}>
                       Datos del cliente
                  </button>
                </div>

                <div>
                    <Dialog
                        title={<DialogTitle text={dialogTitle} closeFn={() => this.onClose()} />}
                        visible={this.state.visible}
                        onClose={this.onClose.bind(this)}
                        closable={false}
                        animation="fade"
                        maskAnimation="slide-down"
                        animationDuration={200}
                        style={{ width: 600 }}
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default btn-secondary ButtonDialogPersona"
                                    key="close"
                                    onClick={this.onClose.bind(this)}
                                >
                                    Cerrar
                                </button>
                            ]
                        }
                    >
                        <ClienteDialogContent cliente={this.props.cliente} />
                    </Dialog>
                </div>

            </div>
        );

    }
}

export default Header;
